import Chartist from 'chartist'

import { transform } from './transform'

export default {
  Chartist,
  install(Vue) {
    /** Chartist setip */
    Object.defineProperty(Vue.prototype, '$Chartist', {
      get() {
        this.$root.Chartist.utils = {
          transform
        }
        return this.$root.Chartist
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/core/charts/index.js